import { Grid2, TextEllipsis } from '@aibees/shared/components';
import { useUserProfileApi } from '@aibees/shared/features/user-profile/hooks/use-user-profile-api';
import { classnames } from '@aibees/shared/utils';
import { useGetUserRole } from '@aibees/shared/workspace';
import { memo } from 'react';
import { UploadProfileAvatar } from '../upload-profile-avatar';
import { ChangeInfoDialog } from './change-info-dialog';
import * as Styled from './styles';
import * as SX from './sx';
import type { UserInformationProps as Props } from './types';
import { capitalizeFirstLetter } from './utils';
import { Stack } from '@mui/material';

export const UserInformation = memo(({ className }: Props) => {
  const userRole = useGetUserRole();

  const { data } = useUserProfileApi();

  return (
    <Styled.Wrapper
      className={classnames('UserInformation', className)}
      sx={SX.root}
    >
      <Grid2 container columns={48}>
        <Grid2 xl={40} lg={40} md={36} sm={36} xs={36} gap={1}>
          <UploadProfileAvatar />
          <Stack width={'78%'}>
            <TextEllipsis variant="body3" fontWeight={700} color="grey.700">
              {data?.firstName} {data?.lastName}
            </TextEllipsis>
            <TextEllipsis variant="body3" fontWeight={400} color="grey.700">
              {data?.attributes?.title}
            </TextEllipsis>
            {userRole && (
              <TextEllipsis variant="body3" fontWeight={400} color="grey.500">
                {capitalizeFirstLetter(userRole)}
              </TextEllipsis>
            )}
          </Stack>
        </Grid2>
        <Grid2 xl={8} lg={8} md={12} sm={12} xs={12} justifyContent="flex-end">
          <ChangeInfoDialog />
        </Grid2>
      </Grid2>
    </Styled.Wrapper>
  );
});

UserInformation.displayName = 'UserInformation';
